import React, {useState} from 'react';
import { Box, Typography } from '@mui/material'
import {IoIosArrowDown} from 'react-icons/io'
import { useUserAuth } from '../login/userAuthContext';
import { useNavigate } from 'react-router';
import {FiUserCheck} from 'react-icons/fi';
import { useContext } from 'react';
import { UsernameContext } from '../login/usernameContext';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';



export function Logout() {
  const {logOut} = useUserAuth();
  const {username} = useContext(UsernameContext);
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleLogout = async()=>{
    try {
        await(logOut());
        setAnchorEl(null)
        navigate("/");
    }catch (error) {
        alert(error.message);
    }
}
  return (
    <div>
      <Button
        id="basic-button"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        endIcon={<KeyboardArrowDownIcon />}
        sx={{textTransform:'none', width:'275px', color:'white', backgroundColor:'red',display:'flex', justifyContent:'space-around', alignItems:'flex-start'}}
      >
        <Box
            display='flex'
            sx={{justifyContent: 'flex-start', alignItems:'flex-start'}}
            >
                <div style={btnlogo}>my</div>
                <Typography 
                variant='body1'
                color= 'white'
                fontSize='12px'
                fontWeight='bold'
                sx={{flexGrow: '1'}}
                ><FiUserCheck style={{fontSize:'30px'}}/>Welcome {username}</Typography>
            </Box>
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        <MenuItem 
        onClick={handleLogout}
        sx={{width:'275px', textAlign:'end'}}
        >Logout</MenuItem>
        
      </Menu>
    </div>
  );
}

const btnlogo = {
    width: '30px',
    height: '30px',
    backgroundColor: 'white',
    borderRadius: '50%',
    fontFamily: 'Damion',
    color: 'blue',
    marginRight: '5px'
}
export function LoginBtn() {
    const navigate = useNavigate();
    const {user} = useUserAuth();
    const btnlogin = {
        width: '275px',
        height: '45px',
        background: !user ? 'linear-gradient(45deg, #03befc, blue)': 'red',
        border:'none',
        borderRadius: '6px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: '18px'
    }
    const handleLogin = ()=>{
        navigate("/login");
    }
    
  return (
    <div>
        {user ? 
            <Logout /> : 
            <button style={btnlogin} onClick={handleLogin}>
            <Box
            display='flex'
            sx={{justifyContent: 'space-between', alignItems:'center'}}
            >
                <div style={btnlogo}>my</div>
                <Typography 
                variant='body1'
                color= 'white'
                fontSize='12px'
                fontWeight='bold'
                sx={{flexGrow: '1'}}
                >Login or Create Account</Typography>
                <IoIosArrowDown style={{color:'white', marginLeft:'40px'}}/>
            </Box>
        </button>
        }
    </div>
  )
}
